"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const waitersService_1 = require("./service/waitersService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)("waiters/fetch", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const waitersService = new waitersService_1.WaitersService(Env_1.APIPATHENV);
        const response = yield waitersService.fetch(payload);
        return response;
    }
    catch (error) {
        throw new Error("Failed to fetch waiters");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("waiters/create", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const waitersService = new waitersService_1.WaitersService(Env_1.APIPATHENV);
        const response = yield waitersService.create(payload);
        return response;
    }
    catch (error) {
        throw new Error("Failed to create waiter");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("waiters/update", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const waitersService = new waitersService_1.WaitersService(Env_1.APIPATHENV);
        const response = yield waitersService.update(payload);
        return response;
    }
    catch (error) {
        throw new Error("Failed to update waiter");
    }
}));
